import { useFormikContext } from 'formik';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';

const useField = () => {
  const {
    errors,
    touched,
    getFieldMeta
  } = useFormikContext();
  const {
    t
  } = useTranslation();
  const hasError = field => get(touched, field) && Boolean(get(errors, field));
  const getErrorText = field => get(touched, field) && t(get(errors, field));
  const isValid = field => {
    const meta = getFieldMeta(field);
    return !(meta === null || meta === void 0 ? void 0 : meta.error);
  };
  return {
    hasError,
    getErrorText,
    isValid
  };
};

export { useField };
